/**
* @file Column component for displaying a string value.
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying a string value
 */
var ColumnStringComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnStringComponent, _super);
    /**
     * Constructs a ColumnStringComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnStringComponent(provider, changeDetector) {
        return _super.call(this, provider, changeDetector) || this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnStringComponent.register = function () {
        ComponentRegistry.register('column', 'string', ColumnStringComponent);
    };
    /**
     * Tries to start an optimised change detection based upon entiy property changes.
     * The component will fallback on angular change detection when failing.
     * @protected
     */
    ColumnStringComponent.prototype.startOptimisedChangeDetection = function () {
        if (this.provider.field.name.split('.').length > 1) {
            // Fix: Edit op Kalender veld medewerker komt niet snel door in de medewerkerslijst. #2991
            // We weten niet naar welke entity in het pad we moeten luisteren.
            // Alternatief zou kunnen zijn dat we naar alle entities in het pad luisteren.
            // Het aantal entities in het pad kunnen dan veranderen bij een bewerking.
            // Terug vallen op anguler is makkelijker.
            return;
        }
        _super.prototype.startOptimisedChangeDetection.call(this);
    };
    return ColumnStringComponent;
}(ColumnBase));
export { ColumnStringComponent };
